import Auth from './view/desktop/Auth';
export default Auth;